import { createContext, useContext, useState } from "react";

const TrialContext = createContext();
export const useTrial = () => useContext(TrialContext);

export const TrialProvider = ({ children }) => {
  // Naturals naturals: no plan/trial/module gating.
  const [trialExpired] = useState(false);
  const [loading] = useState(false);

  return (
    <TrialContext.Provider
      value={{
        trialExpired,
        loading,
      }}
    >
      {children}
    </TrialContext.Provider>
  );
};
